import type { MessageAttachmentDto } from "@multi-chat/shared";

export type AttachmentMediaRenderPath = "provider" | "stored" | "status";

/** FB/IG METADATA_ONLY may render provider CDN URLs until Order 28C/28D. */
export function shouldRenderProviderAttachmentUrl(
  attachment: MessageAttachmentDto,
): boolean {
  return attachment.storageState === "METADATA_ONLY" && Boolean(attachment.url);
}

export function attachmentMediaRenderPath(
  attachment: MessageAttachmentDto,
): AttachmentMediaRenderPath {
  if (shouldRenderProviderAttachmentUrl(attachment)) {
    return "provider";
  }
  if (attachment.storageState === "STORED") {
    return "stored";
  }
  return "status";
}
